import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../views/Home.vue'; // 确保路径正确
import LoginPage from '@/components/LoginPage.vue';
import MainPage from '@/MainPage.vue';

const routes = [
  {
    path:'/',
    redirect:'/LoginPage'
  },
  {
    path: '/LoginPage',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/MainPage',
    name: 'MainPage',
    component:MainPage,
    meta:{
      requiresAuth:true
    }
  }
  // 其他路由配置
];

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/tx/'),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/LoginPage'); // 如果需要登录且未登录，跳转到登录页面
  } else {
    next(); // 否则继续正常跳转
  }
});


export default router;
